
import * as lottie from "../lottieAnimation/index.js";

class Login {

    constructor() {
        this.username = "";
        this.password = "";
        this.signInClicked = false;
        this.registerClicked = false;
        this.forgotPasswordClicked = false;
        this.termsAndConditionsClicked = false;
        this.focusID = "";

        this.init();

        this.watch();
    }

    init() {

        var loadingAnimationContainer = document.getElementById('loadingAnimationContainer');
        if (loadingAnimationContainer) {
            var loadingAnimation = loadingAnimationContainer.children[0];
            if (loadingAnimation) {
                lottie.applyToElement(loadingAnimation);
            }
        }

        var focusElementID = document.getElementById('focusElementID');
        if (focusElementID.value) {
            this.focusID = focusElementID.value;
            var focusOn = document.getElementById(this.focusID);
            if (focusOn) {
                focusOn.focus();
            }
        }
        var triggerSignIn = document.getElementById('triggerSignIn');
        if (triggerSignIn.value == "true") {
            this.signInClicked = true;
        }
        var triggerRegister = document.getElementById('triggerRegister');
        if (triggerRegister.value == "true") {
            this.registerClicked = true;
        }
        var triggerForgotPassword = document.getElementById('triggerForgotPassword');
        if (triggerForgotPassword.value == "true") {
            this.forgotPasswordClicked = true;
        }

        this.getStartImage();

    }

    watch() {

        var self = this;

        var btnSignIn = document.getElementById('btnSignIn');
        btnSignIn.addEventListener('click', self.updateSignInValue.bind(self));
        btnSignIn.addEventListener('keydown', self.signInKeydown.bind(self));
        btnSignIn.addEventListener('focus', self.focusChanged.bind(self));

        var btnRegister = document.getElementById('btnRegister');
        btnRegister.addEventListener('click', self.updateRegisterClicked.bind(self));
        btnRegister.addEventListener('keydown', self.registerKeydown.bind(self));
        btnRegister.addEventListener('focus', self.focusChanged.bind(self));

        var lnkForgotPassword = document.getElementById('forgotPassword');
        lnkForgotPassword.addEventListener('click', self.updateforgotPasswordClicked.bind(self));
        lnkForgotPassword.addEventListener('keydown', self.forgotPasswordKeydown.bind(self));
        lnkForgotPassword.addEventListener('focus', self.focusChanged.bind(self));

        var lnkTermsAndConditions = document.getElementById('linkTermsAndConditions');
        lnkTermsAndConditions.addEventListener('click', self.updateTermsAndConditionsClicked.bind(self));
        lnkTermsAndConditions.addEventListener('keydown', self.termsAndConditionsKeydown.bind(self));
        lnkTermsAndConditions.addEventListener('focus', self.focusChanged.bind(self));

        var usernameInput = document.getElementById('username');
        this.username = usernameInput.value;
        usernameInput.addEventListener('input', self.updateUsernameValue.bind(self));
        usernameInput.addEventListener('focus', self.focusChanged.bind(self));

        var passwordInput = document.getElementById('password');
        this.password = passwordInput.value;
        passwordInput.addEventListener('input', self.updatePasswordValue.bind(self));
        passwordInput.addEventListener('focus', self.focusChanged.bind(self));

    }

    getStartImage() {

        var hour = new Date().getHours();
        var image = document.getElementById('image');
        image.classList.add(this.getTimePeriod(hour));

    }

    getTimePeriod(hour) {

        let period;

        if (hour < 12) {
            period = "morning";
        } else if (hour < 17) {
            period = "afternoon";
        } else {
            period = "evening";
        }
        return period;
    }


    updateUsernameValue(e) {
        this.username = e.target.value;
    }

    updatePasswordValue(e) {
        this.password = e.target.value;
    }

    focusChanged() {
        this.focusID = document.activeElement.id;
    }

    showLoadingAnimation() {
        var loadingAnimationContainer = document.getElementById('loadingAnimationContainer');
        if (loadingAnimationContainer) {
            loadingAnimationContainer.style.display = "block";
        }
        var formActionsDiv = document.getElementById('formActionsDiv');
        if (formActionsDiv) {
            formActionsDiv.classList.add("hideDiv");
        }
    }

    hideLoadingAnimation() {
        var loadingAnimationContainer = document.getElementById('loadingAnimationContainer');
        if (loadingAnimationContainer) {
            loadingAnimationContainer.style.display = "none";
        }
        var formActionsDiv = document.getElementById('formActionsDiv');
        if (formActionsDiv) {
            formActionsDiv.classList.remove("hideDiv");
        }
    }

    updateSignInValue() {
        this.signInClicked = true;
        this.showLoadingAnimation();
    }

    updateRegisterClicked() {
        this.registerClicked = true;
        this.showLoadingAnimation();
    }

    updateforgotPasswordClicked() {
        this.forgotPasswordClicked = true;
        this.showLoadingAnimation();
    }

    updateTermsAndConditionsClicked() {
        this.termsAndConditionsClicked = true;
        this.showLoadingAnimation();
    }

    signInKeydown(e) {
        if (e.code == 'Enter' || e.code == 'NumpadEnter') {
            this.updateSignInValue();
        }
    }

    registerKeydown(e) {
        if (e.code == 'Enter' || e.code == 'NumpadEnter') {
            this.updateRegisterClicked();
        }
    }

    forgotPasswordKeydown(e) {
        if (e.code == 'Enter' || e.code == 'NumpadEnter') {
            this.updateforgotPasswordClicked();
        }
    }

    termsAndConditionsKeydown(e) {
        if (e.code == 'Enter' || e.code == 'NumpadEnter') {
            this.updateTermsAndConditionsClicked();
        }
    }

    setUsername(username) {
        DotNet.invokeMethod('MobileHealthFund.Web', 'SetUsername', username);
    }

    setPassword(password) {
        DotNet.invokeMethod('MobileHealthFund.Web', 'SetPassword', password);
    }

    signIn() {
        DotNet.invokeMethod('MobileHealthFund.Web', 'SignIn');
    }

    register() {
        DotNet.invokeMethod('MobileHealthFund.Web', 'Register');
    }

    forgotPassword() {
        DotNet.invokeMethod('MobileHealthFund.Web', 'ForgotPassword');
    }

    termsAndConditions() {
        DotNet.invokeMethod('MobileHealthFund.Web', 'TermsAndConditions');
    }

}

Login.prototype.toggleAnimation = function (show) {
    if (show) {
        this.showLoadingAnimation();
    } else {
        this.hideLoadingAnimation();
    }
};

Login.prototype.onBlazorStart = function () {
    var usernameInput = document.getElementById('username');
    if (usernameInput) {
        this.setUsername(this.username);
        this.setPassword(this.password);

        // preserve focus, or set to username
        if (this.focusID) {
            var focusOn = document.getElementById(focusID);
            if (focusOn) {
                focusOn.focus();
            }
        } else {
            usernameInput.focus();
        }

        if (this.signInClicked) {
            // var signInButton = document.getElementById('btnSignIn');
            // signInButton.click();
            signIn();
        }
        if (this.registerClicked) {
            register();
        }
        if (this.forgotPasswordClicked) {
            forgotPassword();
        }
        if (this.termsAndConditionsClicked) {
            termsAndConditions();
        }
    }

};



export default Login;


// WEBPACK FOOTER //
// ./project/client/src/core/components/login/login.js